module.exports = __webpack_public_path__ + "static/img/server-bg.0cf2e949.png";